export default "__VITE_ASSET__036af663__"